/**
 * Trunnion AI - Template Category Filter
 * Sidebar/tab filter for template categories with icons and active state.
 */

import {
  Brain,
  Truck,
  Shield,
  ClipboardList,
  Puzzle,
  LayoutGrid,
} from 'lucide-react';
import type { TemplateCategory } from '@/types/template.types';

type CategoryOption = TemplateCategory | 'all';

interface TemplateCategoryFilterProps {
  selected: CategoryOption;
  onChange: (category: CategoryOption) => void;
}

const CATEGORY_CONFIG: {
  value: CategoryOption;
  label: string;
  icon: React.ReactNode;
}[] = [
  { value: 'all', label: 'All Templates', icon: <LayoutGrid className="h-4 w-4" /> },
  { value: 'intelligence', label: 'Intelligence', icon: <Brain className="h-4 w-4" /> },
  { value: 'logistics', label: 'Logistics', icon: <Truck className="h-4 w-4" /> },
  { value: 'cyber', label: 'Cyber', icon: <Shield className="h-4 w-4" /> },
  { value: 'admin', label: 'Admin', icon: <ClipboardList className="h-4 w-4" /> },
  { value: 'custom', label: 'Custom', icon: <Puzzle className="h-4 w-4" /> },
];

export function TemplateCategoryFilter({
  selected,
  onChange,
}: TemplateCategoryFilterProps) {
  return (
    <nav className="flex flex-col gap-1">
      <h3 className="mb-2 px-3 text-xs font-semibold uppercase tracking-wider text-trunnion-slate-400">
        Categories
      </h3>
      {CATEGORY_CONFIG.map(({ value, label, icon }) => {
        const isActive = selected === value;
        return (
          <button
            key={value}
            onClick={() => onChange(value)}
            className={`flex items-center gap-3 rounded-lg px-3 py-2 text-sm font-medium transition-colors ${
              isActive
                ? 'bg-trunnion-gold-500/10 text-trunnion-gold-400 border border-trunnion-gold-500/30'
                : 'text-trunnion-slate-300 hover:bg-trunnion-slate-800 hover:text-white border border-transparent'
            }`}
          >
            <span
              className={
                isActive ? 'text-trunnion-gold-400' : 'text-trunnion-slate-500'
              }
            >
              {icon}
            </span>
            {label}
          </button>
        );
      })}
    </nav>
  );
}
